import styled from '@emotion/styled/macro';

import { StandardText } from '../../../../components/Typography/Typography';

export const StyledStandardText = styled(StandardText)`
  margin-top: 2rem;
`;
